import styled, { css } from 'styled-components';
import { getListWidth } from '@/app/components/search/components/SearchPageContainer/ListContainer/utils.ts';

const mobileNavigationStyles = css`
  & > nav {
    height: 52px;
    position: fixed;
    top: 64px;
    background: white;
    z-index: 3;
    display: flex;
    align-items: center;
    padding: 20px;
    box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.mediumDownShadow};
  }
`;

const mapStyles = css<{ listView: boolean | null; evolutionResultsOnlyEnabled?: boolean }>`
  @media (min-width: 768px) {
    padding-left: 24px;
    padding-right: 24px;
  }

  ${({ listView, evolutionResultsOnlyEnabled }) => !listView && getListWidth(listView, evolutionResultsOnlyEnabled)};
`;

const listStyles = css`
  @media (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }

  @media (min-width: 1024px) {
    .sidebar + & {
      margin-left: 32px;
      max-width: calc(100% - 32px);
    }
  }
`;

const sortStyles = css`
  .openx-ui-listview-sort {
    .openx-ui-sort-modal {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      width: 100%;
      height: 58px;
      border-radius: 8px;
      margin-bottom: 16px;
      overflow: hidden;

      > label {
        display: none;
      }

      > div {
        width: calc((100% - 80px) / 3);
        position: relative;
        border-left: 1px solid ${({ theme }) => theme.kallisto.color.common.black[50]};
        background-color: #fff;
        transition: background-color 0.2s ease-in-out;
        font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
        font-size: ${({ theme }) => theme.kallisto.font.size['175']};

        &:hover {
          background-color: rgba(255, 255, 255, 0.5);
        }

        &.selected-radio {
          color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
          border-bottom: 2px solid ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
        }

        label {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 56px;
          line-height: 56px;
          svg {
            display: none;
          }
        }
      }
    }
  }
`;

export const ListLayoutStyled = styled.div<{
  listView: boolean | null;
  isMobile: boolean;
  isTablet?: boolean;
  evolutionResultsOnlyEnabled?: boolean;
  ref: React.MutableRefObject<HTMLDivElement | undefined>;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  z-index: 2;
  background-color: ${({ evolutionResultsOnlyEnabled, theme }) =>
    evolutionResultsOnlyEnabled
      ? theme.kallisto.color.background.static.backgroundLayer02
      : theme.kallisto.color.background.static.backgroundLayer01};
  transition: width 0.2s cubic-bezier(0.25, 1, 0.5, 1);
  min-width: 0;

  ${({ listView }) => (listView ? listStyles : mapStyles)};
  ${({ isMobile }) => isMobile && mobileNavigationStyles};
  ${sortStyles};
`;

export const FiltersBarContainer = styled.div`
  position: sticky;
  bottom: 16px;
  margin-left: auto;
  margin-right: auto;
  z-index: 2;

  > div {
    position: static;
    left: unset;
    right: unset;
    transform: unset;
  }
`;

export const FiltersBarContainerMobile = styled(FiltersBarContainer)`
  display: flex;
  justify-content: center;

  > div {
    display: inline-flex;
  }
`;
